<template>
  <footer class="footer">
    <div class="footer__main container">
      <div class="footer__brand">
        <RouterLink to="/" class="footer__logo-link">
          <img
            src="/images/about/logo-hp-sm.webp"
            alt="Happy Protection"
            width="28"
            height="28"
            loading="lazy"
          />
          <span class="footer__brand-name">Happy Protection</span>
        </RouterLink>
        <p class="footer__desc">
          Spécialiste de la sécurité privée en Loire-Atlantique.
          Présence terrain, réactivité opérationnelle et sécurisation des sites sensibles.
        </p>
        <div class="footer__cnaps">
          <span class="footer__label">Entreprise autorisée CNAPS</span>
          <span class="footer__cnaps-num">AUT-044-2123-12-09-20240963313</span>
        </div>
      </div>

      <div class="footer__col">
        <h2 class="footer__col-heading">Navigation</h2>
        <ul class="footer__list">
          <li><RouterLink to="/">Accueil</RouterLink></li>
          <li><RouterLink to="/services">Nos services</RouterLink></li>
          <li><RouterLink to="/a-propos">À propos</RouterLink></li>
          <li><RouterLink to="/recrutement">Recrutement</RouterLink></li>
          <li><RouterLink to="/zones-intervention">Zones d'intervention</RouterLink></li>
        </ul>
      </div>

      <div class="footer__col">
        <h2 class="footer__col-heading">Interventions</h2>
        <ul class="footer__list">
          <li>Loire-Atlantique (44)</li>
          <li>Maine-et-Loire (49)</li>
          <li>Vendée (85)</li>
          <li>Nantes</li>
          <li>Rezé</li>
          <li>Saint-Herblain</li>
          <li>Vertou</li>
          <li>Carquefou</li>
        </ul>
      </div>

      <div class="footer__col">
        <h2 class="footer__col-heading">Disponibilité</h2>
        <ul class="footer__list footer__contact-list">
          <li>24h/24 – 7j/7</li>
          <li>
            <span class="footer__label">Téléphone</span>
            <a href="tel:+33661919047">06 61 91 90 47</a>
          </li>
          <li>
            <span class="footer__label">Email</span>
            <a href="mailto:contact@happyprotection.fr">contact@happyprotection.fr</a>
          </li>
          <li>
            <a href="tel:+33661919047" class="footer__callback">
              Être rappelé rapidement
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer__bottom">
      <div class="container footer__bottom-inner">
        <p>© {{ currentYear }} HAPPY PROTECTION Security. Tous droits réservés. Basé à Rezé, Nantes.</p>
        <RouterLink to="/politique-de-confidentialite" class="footer__privacy">Politique de Confidentialité</RouterLink>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear()
</script>

<style scoped>
.footer {
  background-color: var(--color-footer-bg);
  border-top: 1px solid var(--color-footer-border);
}

.footer__main {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sp-6);
  padding-top: var(--sp-8);
  padding-bottom: var(--sp-8);
}

.footer__brand {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.footer__logo-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.footer__brand-name {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-sm);
  color: var(--color-heading);
}

.footer__brand img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.footer__desc {
  font-family: var(--font-body);
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  line-height: 1.625;
}

.footer__cnaps {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 0.5rem;
}

.footer__label {
  font-family: var(--font-body);
  font-size: var(--text-tag);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.0625em;
  color: var(--color-text-muted);
}

.footer__cnaps-num {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: var(--text-xs);
  color: var(--color-text-muted);
}

.footer__col-heading {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.075em;
  color: var(--color-footer-heading);
  padding-bottom: 0.5625rem;
  border-bottom: 1px solid var(--color-footer-border);
  margin-bottom: var(--sp-3);
}

.footer__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer__list li,
.footer__list a {
  font-family: var(--font-body);
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  transition: color 0.2s;
}

.footer__list a:hover {
  color: var(--color-accent);
}

.footer__contact-list {
  gap: var(--sp-2);
}

.footer__contact-list li {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.footer__callback {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.5rem;
  background-color: var(--color-accent);
  color: var(--color-white) !important;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 0.625rem;
  text-transform: uppercase;
  letter-spacing: 0.069em;
  padding: 0.5rem 1rem;
  border-radius: 2px;
  margin-top: 0.5rem;
  transition: opacity 0.2s;
}

.footer__callback:hover {
  opacity: 0.9;
}

.footer__bottom {
  border-top: 1px solid var(--color-footer-border);
}

.footer__bottom-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
  padding-top: var(--sp-3);
  padding-bottom: var(--sp-3);
}

.footer__bottom-inner p,
.footer__bottom-inner a {
  font-family: var(--font-body);
  font-size: var(--text-xs);
  color: var(--color-text-muted);
}

.footer__bottom-inner a:hover {
  opacity: 1;
  color: var(--color-accent);
}

.footer__privacy {
  font-family: var(--font-body);
  font-size: var(--text-xs);
  color: var(--color-text-muted);
  transition: color 0.2s;
}

.footer__privacy:hover {
  color: var(--color-accent);
}

/* Desktop — 4-column grid */
@media (min-width: 768px) {
  .footer__main {
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap: 3rem;
    padding-inline: 2rem;
  }
}
</style>
